import { useDispatch, useSelector } from "react-redux";
import ProjectSettings from "../settings";
import { Dialog, DialogContent } from "../ui/dialog";
import {
  setEditProjectCandidateId,
  setShowAddEditProjectModal,
} from "@/store/projectsSlice";

export const ProjectEditModal = () => {
  const baseProjects = useSelector(
    (state: any) => state.supabaseStore.projects,
  );

  const editProjectCandidateId = useSelector(
    (state: any) => state.projects.editProjectCandidateId,
  );
  const showAddEditProjectModal = useSelector(
    (state: any) => state.projects.showAddEditProjectModal,
  );
  const dispatch = useDispatch();
  const closeAddEditProjectModal = () => {
    dispatch(setShowAddEditProjectModal(false));
    dispatch(setEditProjectCandidateId(null));
  };

  return (
    <Dialog
      open={showAddEditProjectModal}
      onOpenChange={closeAddEditProjectModal}
    >
      <DialogContent>
        <ProjectSettings
          editProjectId={editProjectCandidateId}
          editProjectData={
            editProjectCandidateId
              ? baseProjects?.[editProjectCandidateId]
              : null
          }
          scrollAreaHeight="h-[calc(100vh-200px)]"
        />
      </DialogContent>
    </Dialog>
  );
};
